import { Campaign, WhatsApp } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";
import { useSessionContext } from "../../contexts/SessionContext";
import { CostumerRelationship } from "./CostumerRelationship";
import ClinicalCrmManagementPage from "src-next/applications/mvp/pages/ClinicalCRM";
import { useOrganizationContext } from "@/contexts/OrganizationContext";
import { oids } from "@/configs/Settings";
import { usePostAttendanceContext } from "@/contexts/PostAttendanceContext";

export function useFluxzapCampaigns() {
  const { access, user } = useSessionContext();
  const { organizationId } = useOrganizationContext();
  const { contractPostAttendance } = usePostAttendanceContext();

  const configs: IFeatures = {
    active: access.type === "professional" && !!contractPostAttendance,
    path: "/fluxzap",
    icon: WhatsApp,
    text: "FluxZap",
    sideMenu: true,

    component: () => (
      <ClinicalCrmManagementPage
        organizationId={organizationId}
        practitionerId={`${oids.cpf}-${user?.username}`}
      />
    ),
  };

  return configs;
}
